import Vue from 'vue';
import Vuex from 'vuex';
import gql from 'graphql-tag';

Vue.use(Vuex);

export default {
    namespaced: true,
    state: {
        loaded: false,
        categories: [],
        attributes: {}
    },
    getters: {
        loaded: state => () => {
            return state.loaded;
        },
        getCategoryById: state => id => {
            return state.categories[id] ? Object.assign({}, state.categories[id]) : null;
        },
        categoriesTree: (state, getters) => (categories, parentNodeId) => {
            let result = [];
            let category;
            if (parentNodeId !== null) {
                category = getters.getCategoryById(parentNodeId);
                category.childrenData = getters.categoryChildren(categories, category);
                result.push(category);
            } else {
                for (let categoryId of categories) {
                    category = getters.getCategoryById(categoryId);
                    if (category !== null && category.attributes['data-parent'] == 0) {
                        category.childrenData = getters.categoryChildren(categories, category);
                        result.push(category);
                    }
                }
            }

            return result;
        },
        categoryChildren: (state, getters) => (categories, category) => {
            let result = [];
            if (category != null && Object.keys(category.children).length > 0) {
                for (let categoryId of Object.values(category.children)) {
                    if (categories.includes(categoryId)) {
                        let child = getters.getCategoryById(categoryId);
                        if (child != null) {
                            result.push(child);
                        }
                    }
                }
            }

            return result;
        },
        categoryParents: (state, getters) => (node, parentsList = []) => {
            if (node.attributes['data-parent'] > 0) {
                let parent = getters.getCategoryById(node.attributes['data-parent']);
                if (parent) {
                    parentsList.unshift(parent);
                    parentsList = getters.categoryParents(parent, parentsList);
                }
            }
            return parentsList;
        },
        getCategoryIdByUrl: state => (url, parentId) => {
            for (let categoryId in state.categories) {
                if (state.categories.hasOwnProperty(categoryId)) {
                    let category = state.categories[categoryId];
                    if (
                        (category['url'] == url || category['value'] == url) &&
                        category.attributes['data-parent'] == parentId
                    ) {
                        return categoryId;
                    }
                }
            }
            return null;
        },
        isSearchableAttribute: state => indexname => {
            return state.attributes[indexname] != undefined;
        },
        getCategoriesTreeIds: (state, getters) => (
            categoriesUrlsArray,
            result = null,
            parentId = 0,
            categoriesUrls = null
        ) => {
            if (result === null) {
                result = {};
            }
            let tree = {};
            if (categoriesUrls === null) {
                categoriesUrls = Object.assign({}, categoriesUrlsArray);
            }
            for (let index in categoriesUrls) {
                if (categoriesUrls.hasOwnProperty(index)) {
                    let categoryUrl = categoriesUrls[index];
                    if (categoriesUrlsArray.indexOf(categoryUrl) + 1 != categoriesUrlsArray.length) {
                        let categoryId = getters.getCategoryIdByUrl(categoryUrl, parentId);
                        delete categoriesUrls[index];
                        if (categoryId !== null) {
                            let categoriesTree = getters.getCategoriesTreeIds(
                                categoriesUrlsArray,
                                result,
                                categoryId,
                                categoriesUrls
                            );
                            if (categoriesTree.length > 0) {
                                tree[categoryId] = categoriesTree;
                            }
                        }
                    } else {
                        let categoryUrl = categoriesUrls[index];
                        let categoryId = getters.getCategoryIdByUrl(categoryUrl, parentId);
                        if (categoryId !== null) {
                            tree = [categoryId];
                            result.activeCategory = categoryId;
                        }
                    }
                }
            }
            result.tree = tree;

            return result;
        },
        getNestedCategoriesUrl: (state, getters) => categoryId => {
            let url = '';

            let category = getters.getCategoryById(categoryId);
            if (category !== null) {
                if (url.length > 0) {
                    url = '/' + url;
                }
                url = (!category.url || !category.url.length ? categoryId : category.url) + url;
                if (category.attributes['data-parent'] != 0) {
                    let parentUrl = getters.getNestedCategoriesUrl(category.attributes['data-parent']);
                    if (parentUrl.length > 0) {
                        if (url.length > 0) {
                            url = '/' + url;
                        }
                        url = parentUrl + url;
                    }
                }
            }

            return url;
        },
        getAttributeByIndexname: state => attributeIndexname => {
            return state.attributes[attributeIndexname];
        },
        rootCategories: state => {
            let rootCategories = [];

            Object.values(state.categories).forEach(category => {
                if (category.attributes['data-parent'] === 0) {
                    rootCategories.push(category);
                }
            });

            return rootCategories;
        },
    },
    mutations: {
        update(state, payload) {
            state.loaded = true;
            if (payload.categories) {
                let categories = {};
                for (let i in payload.categories) {
                    if (payload.categories.hasOwnProperty(i)) {
                        categories[payload.categories[i].value] = payload.categories[i];
                    }
                }
                state.categories = categories;
            }
            if (payload.attributes) {
                for (let index in payload.attributes) {
                    if (payload.attributes.hasOwnProperty(index)) {
                        let attribute = payload.attributes[index];
                        state.attributes[attribute['indexname']] = attribute;
                    }
                }
            }
        },
        loaded(state, loaded) {
            state.loaded = loaded;
        }
    },
    actions: {
        loadFilters({ commit, dispatch }) {
            if (!this.state.loaded) {
                return Vue.$graphql
                    .query({
                        query: gql`
                            query searchFilters {
                                searchFilters {
                                    attributes
                                    categories {
                                        value
                                        label
                                        children
                                        description
                                        url
                                        attributes
                                        meta_title
                                        meta_description
                                        category_text_top
                                        category_text_bottom
                                    }
                                    searchConfig
                                }
                            }
                        `
                    })
                    .then(r => r.data)
                    .then(data => {
                        if (data.searchFilters.searchConfig) {
                            dispatch('SearchResults/setSearchConfig', data.searchFilters.searchConfig, {root: true});
                        }
                        commit('update', data.searchFilters);
                        commit('loaded', true);
                    })
                    .catch(() => {
                        commit('loaded', false);
                    });
            }
        }
    }
};
